if (!customElements.get('banner-carousel')) {
  customElements.define(
    'banner-carousel',
    class BannerCarousel extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.banner-carousel__list');
        this.prevButton = this.querySelector('.banner-carousel__arrow--prev');
        this.nextButton = this.querySelector('.banner-carousel__arrow--next');
        this.dotsWrapper = this.querySelector('.banner-carousel__dots');
        if (!this.list) return;

        this.prevButton?.addEventListener('click', () => this.scrollToIndex(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.scrollToIndex(this.currentIndex + 1));
        this.list.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.list);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      get maxScroll() {
        return this.list.scrollWidth - this.list.clientWidth;
      }

      // Cíle šipek = snap pozice jednotlivých slidů (vzdálenost od prvního),
      // oříznuté na maxScroll. Posun o celou šířku viewportu by přeskočil snap
      // point dalšího slidu a mandatory snap by cíl přitáhl až na konec.
      get snapTargets() {
        const slides = this.list.querySelectorAll('.banner-carousel__slide');
        if (!slides.length) return [0];
        const max = this.maxScroll;
        const first = slides[0].offsetLeft;
        const targets = [];
        slides.forEach((slide) => {
          const left = Math.min(slide.offsetLeft - first, max);
          if (!targets.length || left - targets[targets.length - 1] > 1) targets.push(left);
        });
        return targets;
      }

      get currentIndex() {
        const { scrollLeft } = this.list;
        let nearest = 0;
        this.snapTargets.forEach((left, i, targets) => {
          if (Math.abs(left - scrollLeft) < Math.abs(targets[nearest] - scrollLeft)) nearest = i;
        });
        return nearest;
      }

      scrollToIndex(index) {
        const targets = this.snapTargets;
        const target = Math.max(0, Math.min(index, targets.length - 1));
        this.list.scrollTo({
          left: targets[target],
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }

      requestUpdate() {
        if (this.updateScheduled) return;
        this.updateScheduled = true;
        requestAnimationFrame(() => {
          this.updateScheduled = false;
          this.update();
        });
      }

      update() {
        this.prevButton?.toggleAttribute('disabled', this.list.scrollLeft <= 1);
        this.nextButton?.toggleAttribute('disabled', this.list.scrollLeft >= this.maxScroll - 1);
        this.updateDots();
      }

      updateDots() {
        if (!this.dotsWrapper) return;
        const pages = this.snapTargets.length;
        this.dotsWrapper.toggleAttribute('hidden', pages <= 1 || this.maxScroll <= 1);

        if (this.dotsWrapper.children.length !== pages) {
          const label = this.dotsWrapper.dataset.dotLabel || 'Strana';
          this.dotsWrapper.replaceChildren(
            ...Array.from({ length: pages }, (_, i) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'banner-carousel__dot';
              dot.setAttribute('aria-label', `${label} ${i + 1}`);
              dot.addEventListener('click', () => this.scrollToIndex(i));
              return dot;
            })
          );
        }

        const current = this.currentIndex;
        [...this.dotsWrapper.children].forEach((dot, i) => {
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }
    }
  );
}
